import { Component } from '@angular/core';

@Component({
  selector: 'app-footer-contacts',
  templateUrl: './footer-contacts.component.html',
  styleUrls: ['./footer-contacts.component.scss'],
})
export class FooterContactsComponent {}
